import { Component, Inject, OnInit } from '@angular/core';
import { PlatformUserContext } from '@/app/platform/platform-context/platform-user-context';
import {
  PRESENT_DEVICE_USER_ACTIONS,
  PresentDeviceUserActions
} from '@/app/platform/platform-data/actions/types';

@Component({
    selector: 'present-users-filters',
    templateUrl: './present-users-filters.component.html',
    styleUrls: ['./present-users-filters.component.scss'],
    standalone: false
})
export class PresentUsersFiltersComponent implements OnInit {
  constructor(
    readonly platformUserContext: PlatformUserContext,
    @Inject(PRESENT_DEVICE_USER_ACTIONS)
    readonly presentDeviceUserActions: PresentDeviceUserActions
  ) {}

  userGroupIds: string[] = [];

  async updateFilters(): Promise<void> {
    await this.presentDeviceUserActions.setFilters({
      userGroupIds: this.userGroupIds
    });
  }

  async ngOnInit(): Promise<void> {}
}
